<template>
  <el-dialog
    class="dialog"
    :visible.sync="visible"
    title="未含税价明细"
    :close-on-click-modal="false"
    width="1200px"
  >
    <el-input
      v-model.trim="form.itemName"
      placeholder="请输入品目名称"
      class="search-input"
      clearable
      @clear="getQuoteDetail"
      @keyup.enter.native="getQuoteDetail"
    >
      <el-button slot="append" icon="el-icon-search" @click="getQuoteDetail" />
    </el-input>

    <jczh-table-content
      class="m-t-18"
      :data="list"
      :option="listOption"
      pagination
      :total="total"
      :page.sync="page"
      :limit.sync="size"
      @pagination="getQuoteDetail"
    />
    <template v-slot:footer>
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="closeDialog">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getInquiryReviewSupplierQuoteDetailApi } from '@/api/procure/inquiry-review'
import { purchaseTypeDict } from '@/dictionary/project/common'

/**
 * 线上评审报价明细（询比品目报价明细）
 */
export default {
  name: 'MaterialNoRateQuoteDetailDialog',

  props: {
    reviewId: {
      type: [String, Number],
      default: 0
    },

    orderId: {
      type: [String, Number],
      default: 0
    },

    bidder: {
      type: Object,
      default: () => {}
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    },

    offerUnit: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      visible: false,

      list: [],
      total: 0,
      page: 1,
      size: 10,
      form: {
        itemName: ''
      }
    }
  },

  computed: {
    listOption() {
      return [
        { label: '品目', prop: 'itemName' },
        {
          label: '采购量/计量单位',
          prop: '',
          filter: obj => `${obj.itemNum}/${obj.itemUnit}`
        },
        { label: `当前含税价（${this.offerUnit}）`, prop: 'offerPrice' },
        { label: '当前税率（%）', prop: 'offerTaxRate' },
        { label: `未含税价（${this.offerUnit}）`, prop: 'noRateOfferPrice' },
        { label: `报价总金额（${this.offerUnit}）`, prop: 'offerTotalPrice' },
        { label: `总未含税价（${this.offerUnit}）`, prop: 'noRateTotalPrice' }
      ]
    }
  },

  watch: {
    bidder: {
      handler(val) {
        if (val?.supplierId) {
          this.getQuoteDetail()
        }
      }
    }
  },

  methods: {
    openDialog() {
      this.visible = true
      this.getQuoteDetail()
    },

    closeDialog() {
      this.visible = false
      this.form = { itemName: '' }
      this.list = []
    },

    /**
     * 获取当前报价详情
     */
    getQuoteDetail() {
      if (!this.bidder.supplierId) {
        return
      }
      if (this.purchaseType === purchaseTypeDict.INQUIRY.value) {
        const params = {
          orderId: this.orderId,
          supplierId: this.bidder.supplierId,
          ...this.form
        }
        getInquiryReviewSupplierQuoteDetailApi(this.reviewId, params)
          .then(res => {
            this.list = res.data || {}
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.search-input {
  width: 300px;

  ::v-deep .el-input-group__append {
    background: $primary-color;
    color: $white-color;
  }
}
</style>
